/** Bundled fallback when no SPACEY_CONFIG exists for the market. */
import defaultSpaceyIcon from '../../../assets/images/agent/spacey-2026-3d.svg';

export default defaultSpaceyIcon;
